import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2'
import api from '../../components/api/api';
import { ShopContext } from '../../components/context/ShopContext';

export default function List() {
  const {getID, setID} = useContext(ShopContext);

    const [applications, setApplications] = useState([])
    useEffect(()=>{
        fetchApplications() 
    },[])

    const fetchApplications = async () => {
        await api.get(`/trainings`).then(({data})=>{
            setApplications(data)
        })
    }

    const deleteApplication = async (id) => {
        const isConfirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            return result.isConfirmed
          });

          if(!isConfirm){
            return;
          }

          await api.delete(`users/${id}`).then(({data})=>{
            Swal.fire({
                icon:"success",
                text:data.message
            })
            fetchApplications()
          }).catch(({response:{data}})=>{
            Swal.fire({
                text:data.message,
                icon:"error"
            })
          })
    }
    const approveApplication = async (id) => {
        const isConfirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, approve!'
          }).then((result) => {
            return result.isConfirmed
          });

          if(!isConfirm){
            return;
          }

          await api.put(`users/${id}`, {id}).then(({data})=>{
            Swal.fire({
                icon:"success",
                text:data.message
            })
            fetchApplications()
          }).catch(({response:{data}})=>{
            Swal.fire({
                text:data.message,
                icon:"error"
            })
          })
    }

    return (

      <div className="row justify-content-center mt-3" style={{maxWidth:"100%"}}>
        <div className="col-md-12">
            <div className="card">
                <div className="card-header">User List [{applications.length}]</div>
                <div className="card-body">
                    <Link to={"/newuser"} className="btn btn-success btn-sm my-2"><i className="bi bi-plus-circle"></i> New User</Link>
                    <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Type</th>
                            <th scope="col">Date</th>
                            
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                            
                        {
                        applications.length > 0 && (
                            applications.map((row, key)=>(
                                <tr key={key}>
                                <td>{row.surname} {row.firstname} {row.othernames}</td>
                                <td>{row.email}</td>
                                <td>{row.phone}</td>
                                <td>{row.usertype}</td>
                                <td>{row.created_at.substr(0,10)}</td>
                                <td>
                                        <span onClick={()=>setID( "id", row.id, "userdetails")} className="btn btn-warning btn-sm"><i className="bi bi-eye"></i> View</span>
    
                                        <span onClick={()=>setID( "id", row.id, "edituser")} className="btn btn-primary btn-sm"><i className="bi bi-pencil-square"></i> Edit</span>   
     
                                        {/* <button type="submit" className="btn btn-danger btn-sm"  onClick={()=>deleteApplication(row.id)}><i className="bi bi-trash"></i> Delete</button>  */}
                                        {/* <button type="submit" className="btn btn-danger btn-sm"  onClick={()=>approveApplication(row.id)}><i className="bi bi-tick"></i> Approve</button>   */}
                                </td>
                                </tr>
                                    ))
                                    )
                                }
                        </tbody>
                      </table>
                </div>
            </div>
        </div>    
    </div>
    )
}